module.exports = __webpack_public_path__ + "img/avatar2.2c13bde8.png";